import { useActionPlan } from '@/queries/action-plan.queries';
import { InterventionStatus } from '../../../types';
import { groupByMonth } from './utils/group-by-month';

export default function useCompletedInterventionsController() {
  const { data: actionPlanData, isLoading } = useActionPlan();

  const { interventions } = actionPlanData || {};

  if (!interventions) return { interventions, isLoading };

  const filteredInterventions = interventions.filter(
    ({ status: interventionStatus }) => interventionStatus === InterventionStatus.COMPLETED
  );

  const groupedInterventions = groupByMonth(filteredInterventions);

  return { interventions: groupedInterventions, isLoading };
}
